/*=============================================== ThemeProviderPage ===============================================*/

import { useContext } from "react"
import {
    ThemeContext,
    Flexbox,
    Button,
    Text,
    CodeContainer,
} from "tsx-library-julseb"
import type { ThemeContextProps } from "tsx-library-julseb/types"

import { LangContext } from "context"
import type { LangContextType } from "context"

import { ComponentsLayout } from "components"
import type { ItemType } from "components"

const ThemeProviderPage = () => {
    const { selectedTheme, toggleTheme } = useContext(
        ThemeContext
    ) as ThemeContextProps
    const { language } = useContext(LangContext) as LangContextType

    const items: ItemType[] = [
        {
            title: "Demo",
            content: (
                <Flexbox
                    flexDirection="column"
                    gap="xs"
                    alignItems="flex-start"
                >
                    <Button onClick={toggleTheme}>Toggle theme</Button>
                    <Text>Selected theme: {selectedTheme}</Text>
                </Flexbox>
            ),
            code: "<Button onClick={toggleTheme}>Toggle theme</Button>\n<Text>Selected theme: {selectedTheme}</Text>",
        },
    ]

    return (
        <ComponentsLayout items={items}>
            <Text tag="h2">How to use</Text>

            <Text>
                First, open your <code>index.js</code> file, and add these
                lines:
            </Text>

            <CodeContainer language="javascript">
                {`import { ThemeProviderWrapper } from "tsx-library-julseb"\n\nconst root = ReactDOM.createRoot(document.getElementById("root"))\nroot.render(\n    <ThemeProviderWrapper>\n        <App />\n    </ThemeProviderWrapper>\n)`}
            </CodeContainer>

            <Text>
                Then, open your <code>App.js</code> and add:
            </Text>

            {language === "ts" ? (
                <CodeContainer language="typescript">
                    {`import { ThemeProvider, ThemeContext } from "tsx-library-julseb"\nimport type { ThemeContextProps } from "tsx-library-julseb/types"\n\nconst App = () => {\n    const { theme, toggleTheme } = useContext(ThemeContext) as ThemeContextProps\n\n    return (\n        <ThemeProvider theme={theme}>\n            <Button onClick={toggleTheme}>Toggle theme</Button>\n            ...your app\n        </ThemeProvider>\n    )\n}`}
                </CodeContainer>
            ) : (
                <CodeContainer language="javascript">
                    {`import { ThemeContext, ThemeProvider, Button } from "tsx-library-julseb"\n\nconst App = () => {\n    const { theme, toggleTheme } = useContext(ThemeContext)\n    \n    return (\n        <ThemeProvider theme={theme}>\n            <Button onClick={toggleTheme}>Toggle theme</Button>\n            ...your app\n        </ThemeProvider>\n    )\n}`}
                </CodeContainer>
            )}
        </ComponentsLayout>
    )
}

export default ThemeProviderPage
